import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useLang } from "@/context/LangContext";
import { WEDDING_DATE_ISO } from "@/i18n";

const calcDiff = (target) => {
  const now = new Date().getTime();
  const diff = Math.max(0, target - now);
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const seconds = Math.floor((diff / 1000) % 60);
  return { days, hours, minutes, seconds, finished: diff === 0 };
};

const Unit = ({ value, label, testid }) => (
  <div className="flex flex-col items-center px-4 md:px-8" data-testid={testid}>
    <div className="font-serif text-5xl md:text-7xl text-wine tabular-nums leading-none">
      {String(value).padStart(2, "0")}
    </div>
    <div className="mt-3 text-[10px] md:text-[11px] tracking-[0.35em] uppercase text-olive">
      {label}
    </div>
  </div>
);

const Countdown = () => {
  const { t } = useLang();
  const target = new Date(WEDDING_DATE_ISO).getTime();
  const [time, setTime] = useState(() => calcDiff(target));

  useEffect(() => {
    const id = setInterval(() => setTime(calcDiff(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  return (
    <section
      data-testid="countdown-section"
      className="py-24 md:py-32 px-6"
    >
      <div className="max-w-4xl mx-auto text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-[11px] tracking-[0.4em] uppercase text-olive mb-12"
        >
          {t.countdown.label}
        </motion.p>
        {time.finished ? (
          <p className="font-script text-6xl md:text-7xl text-wine">{t.countdown.finished}</p>
        ) : (
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="flex justify-center items-stretch divide-x divide-gold/30"
          >
            <Unit value={time.days} label={t.countdown.days} testid="countdown-days" />
            <Unit value={time.hours} label={t.countdown.hours} testid="countdown-hours" />
            <Unit value={time.minutes} label={t.countdown.minutes} testid="countdown-minutes" />
            <Unit value={time.seconds} label={t.countdown.seconds} testid="countdown-seconds" />
          </motion.div>
        )}
      </div>
    </section>
  );
};

export default Countdown;
